<template>
<div>
  
  <router-view></router-view>
  <!-- Footer Area Starts -->
  <footer class="footer-area response">
    <div class="marginauto footercon text-white">
      <div class="text-center text-six martwl pointer" style="font-weight: 600;font-size: 20px">友情链接</div>
      <div class="text-four flex justify-center align-center marbot">
        <div class="flex justify-center align-center" v-for="(item,index) in list" :key="index">
          <div class="pointer conone" @click="toout(item.href)">{{item.name}}</div>
          <div v-if="index < list.length-1" class="rightline"></div>
        </div>
      </div>
      <div class="horline"></div>
      <div class="flex justify-between align-center text-four bcolor">
        <div>
          <div class="pointer marf">地址：{{config.address ? config.address : ''}}</div>
          <div class="pointer">电话：{{config.phone ? config.phone : ''}}</div>
        </div>
        <div>
          <div class="pointer marf" @click="toout('https://beian.miit.gov.cn/')">备案号：{{config.beianhao ? config.beianhao : ''}}</div>
          <div class="pointer">版权所有：{{config.banquan ? config.banquan : ''}}</div>
        </div>
      </div>
    </div>
  </footer>
  <!-- Footer Area End -->

</div>
</template>
<script>
export default {
  name: 'app',
  data(){
    return{
      list:[
        '郑州市工业和信息化局','郑州市人力资源和社会保障局','郑州市科技局','郑州政务服务网','郑州市人民政府'
      ],
      config: ''
    }
  },
  methods:{
    getlink(){
      this.$api.user.getlinks().then(res=>{
        // console.log()
        this.list = res.data;
      })
    },
    toout(href){
      window.open(href)
    },
    getconfig(){
      this.$api.index.config().then(response => {
        // this.list = response.data.items
        // console.log(response)
        this.config = response.data;
        var s = JSON.stringify(response.data)
        localStorage.setItem('config', s)
      })
    },
  },
  created(){
    this.getconfig();
    this.getlink();
  }
}
</script>

<style scoped>
  .conone:hover{
    color: #006bef;
  }
</style>


// WEBPACK FOOTER //
// App.vue?70280002